import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import qs from "qs";
import {
  getStockTagList,
  createStockTag,
  editStockTag,
  removeStockTag,
  removeStockTagItem,
  addItemsToTag,
} from "../api";
import { errorMessage, successMessage } from "../../../utils/helper";

const stockTagKeys = {
  all: ["stock-tags"],
  list: (filters) => [...stockTagKeys.all, "list", { filters }],
};

export const useStockTagQueries = ({ resetDeleteInfo, debouncedText } = {}) => {
  const queryClient = useQueryClient();

  let params = {};
  if (debouncedText) {
    params = { ...params, search: debouncedText };
  }
  const query = qs.stringify(params, {
    paramsSerializer: (params) => qs.stringify(params, { encode: true }),
  });

  // List query
  const listQuery = useQuery({
    queryKey: stockTagKeys.list(query),
    queryFn: () => getStockTagList(query),
  });

  // Create tag
  const createTag = useMutation({
    mutationFn: createStockTag,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: stockTagKeys.all,
      });
      successMessage(_.message);
      variables.handleClose();
    },
  });

  // Update tag
  const updateTag = useMutation({
    mutationFn: editStockTag,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: stockTagKeys.all,
      });
      successMessage(_.message);
      variables.handleClose();
    },
  });

  // Delete tag
  const deleteTag = useMutation({
    mutationFn: removeStockTag,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (res) => {
      if (res.success) {
        queryClient.invalidateQueries({
          queryKey: stockTagKeys.all,
        });
        successMessage(res.message);
        resetDeleteInfo();
      } else if (res.success === false) {
        errorMessage(res.message);
      }
    },
  });

  // Delete tag item
  const deleteTagItem = useMutation({
    mutationFn: removeStockTagItem,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (res) => {
      if (res.success) {
        queryClient.invalidateQueries({
          queryKey: stockTagKeys.all,
        });
        successMessage(res.message);
        resetDeleteInfo();
      } else if (res.success === false) {
        errorMessage(res.message);
      }
    },
  });

  // Add items to tag
  const addItems = useMutation({
    mutationFn: addItemsToTag,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: stockTagKeys.all,
      });
      successMessage(_.message);
      variables.handleClose();
    },
  });

  return {
    listQuery,
    createTag,
    updateTag,
    deleteTag,
    deleteTagItem,
    addItems,
  };
};
